import { Component } from 'react';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import MissingImageIcon from '../icons/missing_image_icon';

import classes from './img_with_fallback.less';
import classNames from 'classnames';

type Props = {
  src: string | null;
  className?: string;
};

type State = {
  loadFailed: boolean;
};

export default class ImgWithFallback extends Component<Props, State> {
  state = {
    loadFailed: false,
  };

  handleOnError = () => {
    this.setState({ loadFailed: true });
  };

  render() {
    const { src: imageUrl, className } = this.props;

    return !this.state.loadFailed ? (
      <img
        data-src={imageUrl}
        className={classNames(className, 'lazyload')}
        onError={this.handleOnError}
      />
    ) : (
      <div className={classNames(classes.fallbackIcon, className)}>
        <MissingImageIcon />
      </div>
    );
  }
}
